"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DataConnectionIcon_1 = require("./DataConnectionIcon");
var rowStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: 6,
    marginBottom: 6
};
var iconStyle = {
    verticalAlign: 'text-bottom',
    marginRight: 3
};
function DataConnectionRowComponent(props) {
    var displayName = React.createElement("span", null, props.displayName);
    if (props.connectionType === 'TableauServer' && props.url) {
        displayName = React.createElement("a", { href: props.url }, props.displayName);
    }
    else if (props.connectionType === 'ExternalServer' && props.externalServer) {
        displayName = React.createElement("span", null, props.externalServer);
    }
    return (React.createElement("li", { style: rowStyle },
        React.createElement(DataConnectionIcon_1.DataConnectionIconComponent, { style: iconStyle, isCertified: props.isCertified, connectionType: props.connectionType }),
        displayName));
}
exports.DataConnectionRowComponent = DataConnectionRowComponent;
//# sourceMappingURL=DataConnectionRow.js.map